import { render, staticRenderFns } from "./ExamExplain.vue?vue&type=template&id=9be2c72e&scoped=true&"
import script from "./ExamExplain.vue?vue&type=script&lang=js&"
export * from "./ExamExplain.vue?vue&type=script&lang=js&"
import style0 from "./ExamExplain.vue?vue&type=style&index=0&id=9be2c72e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be2c72e",
  null
  
)

export default component.exports